var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n    font-family: 'Futura (Light)';\n    src: url(" + escape(require("./FuturaLight.eot")) + ");\n    src: url(" + escape(require("./FuturaLight.eot")) + "?#iefix) format('embedded-opentype'),\n        url(" + escape(require("./FuturaLight.woff2")) + ") format('woff2'),\n        url(" + escape(require("./FuturaLight.woff")) + ") format('woff'),\n        url(" + escape(require("./FuturaLight.ttf")) + ") format('truetype'),\n        url(" + escape(require("./FuturaLight.svg")) + "#FuturaLight) format('svg');\n    font-weight: 300;\n    font-style: normal;\n}\n\n", ""]);

// exports
